export default __webpack_public_path__ + "static/media/podLogoWithText.cf1d6fbe.svg";